/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeRewardRequest
 */
export interface DistributeRewardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DistributeRewardRequest
     */
    userIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DistributeRewardRequest
     */
    rewardConfigId: string;
}

/**
 * Check if a given object implements the DistributeRewardRequest interface.
 */
export function instanceOfDistributeRewardRequest(value: object): value is DistributeRewardRequest {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('rewardConfigId' in value) || value['rewardConfigId'] === undefined) return false;
    return true;
}

export function DistributeRewardRequestFromJSON(json: any): DistributeRewardRequest {
    return DistributeRewardRequestFromJSONTyped(json, false);
}

export function DistributeRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeRewardRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'rewardConfigId': json['rewardConfigId'],
    };
}

export function DistributeRewardRequestToJSON(json: any): DistributeRewardRequest {
    return DistributeRewardRequestToJSONTyped(json, false);
}

export function DistributeRewardRequestToJSONTyped(value?: DistributeRewardRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'rewardConfigId': value['rewardConfigId'],
    };
}

